var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 512,
    viewBox: "0 0 418 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.401 330.1H114.301C103.301 330.1 94.3008 339.1 94.3008 350.1C94.3008 361.1 103.301 370.1 114.301 370.1H161.401C172.401 370.1 181.401 361.1 181.401 350.1C181.401 339.1 172.401 330.1 161.401 330.1Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.2 129.9L287.5 23.3C272.5 8.2 252.6 0 231.4 0H100C44.9 0 0 44.9 0 100V412C0 467.1 44.9 512 100 512H317.4C372.5 512 417.4 467.1 417.4 412V186C417.4 164.8 409.1 144.9 394.2 129.9ZM365.9 158.2C368.2 160.5 370.2 163.1 371.9 165.8H305C279.4 165.8 258.6 145 258.6 119.4V51L259.2 51.6L365.9 158.2ZM317.4 472.1H100C66.9 472.1 40 445.2 40 412.1V100C40 66.9 66.9 40 100 40H218.6V119.4C218.6 167 257.3 205.8 305 205.8H377.4V412C377.4 445.1 350.5 472 317.4 472V472.1Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 417.4,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.10b19a7332140c58a4377bca2415197d.svg";
export { ForwardRef as ReactComponent };